module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0943.48fedbd7.jpg";